import React, { useEffect, useState } from 'react';

import styled from '@emotion/styled';

import KycRequired from '../../../components/Cards/KycRequired';
import { Modal } from '../../../components/Modal/Modal';
import KycInformationModal from '../../../components/Modal/ModalActions/KycInformationModal/KycInformationModal';
import { useSegmentedViewIndex } from '../../../components/SegmentedViewController';
import { useAppSelector } from '../../../redux/store';
import IncidentDistribution from './IncidentDistribution';
import DrivePerformanceChart from './LineChart/DrivePerformanceChart';

const PerformanceMetrics = () => {
  const { kycStatusData } = useAppSelector((state) => state.kycStatusData);
  const activeSegmentIndex = useSegmentedViewIndex();
  const [showKycSetupFormModal, setShowKycSetupFormModal] = useState(false);
  const [showKycRequiredModal, setShowKycRequiredModal] = useState(false);

  const shouldShowModal =
    activeSegmentIndex === 1 &&
    ['Declined', 'Rejected', 'Pending', 'Not Initialized'].includes(
      kycStatusData?.kycStatus ?? '',
    );

  useEffect(() => {
    // setShowKycSetupFormModal(shouldShowModal);
    setShowKycRequiredModal(true);
  }, [shouldShowModal]);

  const successActionFnViewPerformanceMetrics = () => {
    setShowKycRequiredModal(false);
    setShowKycSetupFormModal(true);
  };

  return (
    <Container>
      {['Declined', 'Rejected', 'Pending', 'Not Initialized'].includes(
        kycStatusData?.kycStatus ?? '',
      ) ? (
        <>
          <Modal
            showModal={showKycRequiredModal}
            setShowModal={setShowKycRequiredModal}
          >
            <KycRequired
              successActionFn={successActionFnViewPerformanceMetrics}
              message='You need to complete your KYC to see performance metrics'
            />
          </Modal>
          <Modal
            showModal={showKycSetupFormModal}
            setShowModal={setShowKycSetupFormModal}
          >
            <KycInformationModal />
          </Modal>
        </>
      ) : (
        <>
          <DrivePerformanceChart />
          <IncidentDistribution />
        </>
      )}
    </Container>
  );
};

export default PerformanceMetrics;

const Container = styled.div`
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
`;
